import React, { useState } from 'react'
import {Navigate, useNavigate} from "react-router-dom"


export default function Topbar(props) {
  const [home,sethome]=useState("")
  const [about,setabout]=useState("")
  const [contact,setcontact]=useState("")
  const [faq,setfaq]=useState("")
  const [howto,sethowto]=useState("")
  setTimeout(() => {
    switch (props.option) {
      case "about":
        setabout("topnvelemsAfter topnvelmsSelected")
        break;
      case "contact":
        setcontact("topnvelemsAfter topnvelmsSelected")
        break;
      case "faq":
        setfaq("topnvelemsAfter topnvelmsSelected")
        break;
      case "howto":
        sethowto("topnvelemsAfter topnvelmsSelected")
        break;
    
      default:
        break;
    }
  }, 0);
 
  const navigate=useNavigate();
  return (
      <div className="topnav flex" style={{width:"100%"}}>
      <div className={`topnvelems ${home}`} id="topnvelem-id2" onClick={()=>{navigate('/playground');window.location.reload()}} >Home</div>
      <div className={`topnvelems ${about}`} id="topnvelem-id3" onClick={()=>{navigate('/about')}} >About</div>
      <div className={`topnvelems ${contact}`} id="topnvelem-id4" onClick={()=>{navigate('/contact')}} >Contact</div>
      <div className={`topnvelems ${faq}`} id="topnvelem-id5" onClick={()=>{navigate('/faq')}} >FAQ</div>
      <div className={`topnvelems ${howto}`} id="topnvelem-id6" onClick={()=>{navigate('/howto')}} >How to</div>
    </div>
   
  )
}
